/* eslint-disable  */

import { createContext } from 'react'
import { ToastProps } from './Toast.types'

export const ToastContext = createContext<(params: ToastProps) => void>(null)
